import { render, staticRenderFns } from "./TemplateBuilder.vue?vue&type=template&id=2713ec19&scoped=true&"
import script from "./TemplateBuilder.vue?vue&type=script&lang=js&"
export * from "./TemplateBuilder.vue?vue&type=script&lang=js&"
import style0 from "./TemplateBuilder.vue?vue&type=style&index=0&id=2713ec19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2713ec19",
  null
  
)

export default component.exports